/* eslint-disable @altermaind/you-shall-not-pass */
// Auto-generated from OpenAPI enums. Do not edit manually.

export enum TeamMemberTypeFilter {
  DEPARTMENTMANAGER = 'departmentManager',
  TEAMMANAGER = 'teamManager',
}

export enum JobStatus {
  CREATED = 'CREATED',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export enum AccountStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  PENDING = 'PENDING',
  NOT_INVITED = 'NOT_INVITED',
}

export enum SanityWarningType {
  DEPARTMENT_BECOMES_EMPTY = 'DEPARTMENT_BECOMES_EMPTY',
  DEPARTMENT_LOSES_MANAGER = 'DEPARTMENT_LOSES_MANAGER',
}

export enum EmployeeAccountStatus {
  NOT_INVITED = 'NOT_INVITED',
  PENDING = 'PENDING',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export enum RoleGroup {
  USERS = 'USERS',
  ADMINISTRATORS = 'ADMINISTRATORS',
}
